















import ripple from "./ripple.vue";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        ripple
    }
})
export default class Checkbox extends Vue {
    @Prop({}) label:string;
    @Prop({}) checked:boolean;

    @Prop({}) readonly:boolean;

    checkboxToggle(){
        if(this.readonly) {return;}
        this.$emit('check', !this.checked);
    }
}

